import { Card } from "antd";
import { Regions } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function ViewPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Regions", href: "/regions" },
          { title: "Details", href: `/regions/view/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Region Details</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <Regions.View id={id} />
          </Card>
        </div>
      </div>
    </div>
  );
}
